import { defineMessage } from 'services/localization';

export const messages = {
    fileTooBigError: defineMessage('file_size_exceeds_maxsize'),
    fileExtensionNotSupportedError: defineMessage('invalid_file_type'),
};
